export const environment = {
    production: false,
    googleMapsApiKey: "AIzaSyCmbudostmn4gBYvXKOpYR0y0WN3PLfZnU",
    firebase: {
        apiKey: "AIzaSyAAfLb5G2yjcesJKhvaEeVt3g4UZBhccoQ",
        authDomain: "fotoshop-test.firebaseapp.com",
        projectId: "fotoshop-test",
        storageBucket: "fotoshop-test.appspot.com",
        messagingSenderId: "503774828000",
        appId: "1:503774828000:web:9e64a6a13d65080b4a0785",
        measurementId: "G-9B6RQFPKSL",
        vapidKey: "BGpigntV2Y_wzMea91Ew_J_RH_gYbJ9xDKqNIIindJchXcYa8QpV16iNro2ISWebw_Jxr8tCiHxnzgt49172Jw8"
    }
};